export default "__VITE_ASSET__C7CDK9AE__"